import { render, staticRenderFns } from "./PageAddonCharacterBuilder.vue?vue&type=template&id=1e8da862&scoped=true&"
import script from "./PageAddonCharacterBuilder.vue?vue&type=script&lang=js&"
export * from "./PageAddonCharacterBuilder.vue?vue&type=script&lang=js&"
import style0 from "./PageAddonCharacterBuilder.vue?vue&type=style&index=0&id=1e8da862&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8da862",
  null
  
)

export default component.exports